import React from 'react';

import { bool, object, string } from 'prop-types';

import { FullContainer, Container } from '../../styles';

import { Info, Phone, LinkStyled } from './styles';

const HeaderContact = ({ blog, stores, top }) => {
  const contacts = [
    {
      href: blog,
      name: 'Blog',
      show: blog,
      target: '_blank',
    },
    {
      href: '/lojas',
      name: 'Lojas',
      show: stores,
    },
    {
      href: '/atendimento',
      name: 'Central de Atendimento',
      show: true,
    },
    {
      href: '/contato',
      name: 'Contato',
      show: true,
    },
    {
      href: '/totem',
      name: 'Pagar agora',
      show: true,
    },
  ];

  return (
    <FullContainer container background="#f5f5f5">
      <Container container>
        <Phone>
          <LinkStyled href={top.link} title={top.title}>
            {top.title}
          </LinkStyled>
        </Phone>
        {contacts.map(
          (contact, i) =>
            contact.show && (
              // eslint-disable-next-line react/no-array-index-key
              <Info key={i}>
                <LinkStyled href={contact.href} target={contact.target} title={contact.name}>
                  {contact.name}
                </LinkStyled>
              </Info>
            )
        )}
      </Container>
    </FullContainer>
  );
};

HeaderContact.defaultProps = {
  top: {},
};

HeaderContact.propTypes = {
  blog: string,
  stores: bool,
  top: object,
};

export default HeaderContact;
